module.exports = __webpack_public_path__ + "media/images/business/i-efficiency-404c8007916ef26ba2d6eb49c9dcba91.svg";